<template>
	<div class="balloon-halloween">
		<svg-sprite width="40" height="40" icon-id="balloon-halloween" halloween></svg-sprite>
	</div>
</template>

<script>
export default {
	name: "balloon-halloween",
	mounted() {
		this.initBalloonWiggle();
	},
	beforeDestroy() {
		if (this._balloonTimer) clearInterval(this._balloonTimer);
	},
	methods: {
		/**
		 * Виставляє випадкові параметри покачування кульки.
		 * @returns {void}
		 */
		initBalloonWiggle() {
			const el = this.$el && this.$el.querySelector('.balloon-halloween');
			if (!el) return;

			const applyRandom = () => {
				// амплітуда 4..6 px
				const amp = `${ Math.floor(4 + (Math.random() * 3)) }px`;
				// швидкість 1.4..2.0 s
				const speed = `${ (1.4 + (Math.random() * 0.6)).toFixed(2) }s`;

				el.style.setProperty('--wiggle-amp', amp);
				el.style.setProperty('--wiggle-speed', speed);
			};

			applyRandom();
			// час від часу змінюємо, щоб «жило»
			this._balloonTimer = setInterval(applyRandom, 4000 + (Math.random() * 2000));
		}
	}
};
</script>

<style lang="scss">
.btnWrapAuthorization {
	position: relative;

	button { position: relative; z-index: 10; }

	.balloon-halloween {
		position: absolute;
		z-index: 1;
		top: -7px;
		right: 10%;

		/* змінні для анімації */
		--wiggle-amp: 5px;
		--wiggle-speed: 3.6s;

		/* базове покачування (по замовчуванню) */
		animation: balloon-wiggle var(--wiggle-speed) ease-in-out infinite alternate;
		will-change: transform;
	}

	.danger:hover ~ .halloween-zone .balloon-halloween {
		animation: balloon-fly-away 10s cubic-bezier(.22,.61,.36,1) forwards;
		pointer-events: none;
	}

	@keyframes balloon-wiggle {
		0%   { transform: translateX(0) rotate(-1deg); }
		25%  { transform: translateX(calc(var(--wiggle-amp) * -1)) rotate(-2deg); }
		50%  { transform: translateX(calc(var(--wiggle-amp))) rotate(2deg); }
		75%  { transform: translateX(calc(var(--wiggle-amp) * -0.6)) rotate(-1deg); }
		100% { transform: translateX(calc(var(--wiggle-amp) * 0.6)) rotate(1deg); }
	}

	@keyframes balloon-fly-away {
		0%   { transform: translate(0,0) scale(1); opacity: 1; }
		60%  { transform: translate(20vw,-60vh) scale(0.92); }
		100% { transform: translate(60vw,-120vh) scale(0.85); opacity: 0; }
	}

	@media (prefers-reduced-motion: reduce) {
		.balloon-halloween { animation: none !important; }
	}
}
</style>
